// extracted by mini-css-extract-plugin
export default {"selectRoleContainer":"SelectRole_selectRoleContainer__dvMM+","select":"SelectRole_select__gFISm"};